import type { FaireProductEntity } from "../../entity_types/product";

export const p_kd383pnvz6: FaireProductEntity = {
  token: "p_kd383pnvz6",
  type: "product",
  name: "Peachy Pits Natural Deodorant Refill – Citrus & Vanilla",
  brandToken: "b_7t7wu79e8q",
  brandName: "Terra and Self",
  imageUrl:
    "https://cdn.faire.com/fastly/78672ed461417a60db1624bf6276f5a149a4044abe4d82c51954ba32207dea0c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22ef8a3eb212ff81c733ec6fa7bcd8fd54572757b4804c22e2558c7da35cc3fd.jpeg",
    "https://cdn.faire.com/fastly/cfa27567765f0ecc7eae80192bae9d6747612a6e4f8674cea00022c3566b0aed.png",
    "https://cdn.faire.com/fastly/fb0f422a70f67182a63b34d9bed30b36e6b787af640166882b5296fc3393773d.png",
    "https://cdn.faire.com/fastly/1324d8978b7e43796e5d993df7e562f9538ce5ea5d0ed41dfd4224a68dda98e0.png",
  ],
  priceDollars: 6.24,
  description:
    "Peachy Pits smells like sunshine and good energy. Juicy orange and grapefruit burst first, balanced by soft bergamot and a smooth hint of vanilla. It’s bright, flirty, and a little sweet, like fresh fruit on warm skin. Powered by magnesium for all day odor protection that never quits.\n\nFeatures:\n-Plastic free and fully compostable refill\n-Gentle, aluminum free, and baking soda free formula\n-Magnesium powered odor protection that lasts all day\n-Smooth texture that won’t stain or irritate skin\n-Fresh, citrusy, and subtly sweet scent profile\n-Designed for Terra & Self refillable deodorant tubes\n-Vegan, cruelty free, handcrafted in small batches\n",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:15.376Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
